// extracted by mini-css-extract-plugin
export default {"page":"kj-z","cartModal":"lj-z","checkout":"mj-z","placeholder":"nj-z","account":"oj-z"};